import { configureStore } from "@reduxjs/toolkit";
import metadataReducer from "../domain/slices/metadataSlice";

const store = configureStore({
  reducer: {
    metadata: metadataReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
